<script>
export default {
  data () {
    return {
      initialized: false,
    }
  },

  render: function (h) {
    // if DOMcontent exists && initalize hasn't run already
    if (this.$slots.default && !this.initialized) {
      this.$nextTick(() => this.initialize())
    };

    return h('div', { class: 'cm-masonry-layout' },
      // each child must be wrapped in a div for reliable sizing
      (this.$slots.default || []).map(child =>
        h('div', {class: 'cm-masonry-layout__item'}, [child])
      )
    )
  },

  mounted() {
    window.addEventListener("resize", this.layoutAllGridItems);
  },

  updated() {
    this.layoutAllGridItems()
  },

  methods: {
    layoutGridItem(item) {
      const grid = this.$el;
      const style = window.getComputedStyle(grid)
      const rowHeight = parseInt(style.getPropertyValue("grid-auto-rows"));
      const rowGap = parseInt(style.getPropertyValue("grid-row-gap"));
      const rowSpan = Math.ceil(
        (item.children[0].getBoundingClientRect().height + rowGap)
        / (rowHeight + rowGap)
      );
      item.style.gridRowEnd = `span ${rowSpan}`;
    },

    layoutAllGridItems() {
      ;[...this.$el.children].forEach(item => {
        this.layoutGridItem(item);
      })
    },

    resizeInstance(instance) {
      item = instance.elements[0];
      this.layoutGridItem(item);
    },

    initialize() {
      // only run once
      this.initialized = true

      const images = [...this.$el.querySelectorAll('img')];

      // checks if promise exists on browser before running
      if (Promise && Promise.hasOwnProperty('allSettled')) {
        // better user-facing solution to laying out items because we continually
        // layout the grid while images are loading, making the reflows seem more natural
        // setInterval uses the wrong `this` so we re-scope it:
        const _this = this

        // run layout calculator every 0.3s until we cancel it
        const layoutInterval = setInterval(_this.layoutAllGridItems, 300)

        const imageLoadPromises = images.map(img => new Promise((resolve, reject) => {
          img.addEventListener('load', resolve)
          img.addEventListener('error', reject)
        }))

        Promise.allSettled(imageLoadPromises).then((results) => {
          clearInterval(layoutInterval)

          // run one last time just in case
          this.layoutAllGridItems()
        })
      } else { // chunkier but simpler method for IE / FF-Android / ?
        images.forEach(img => {
          img.addEventListener('load', this.layoutAllGridItems)
        })
      }

    }
  },
};
</script>

<style lang="scss" scoped>
.cm-masonry-layout {
  display: grid;
  grid-gap: 2rem;
  grid-template-columns: repeat(auto-fill, minmax(16rem, 1fr));

  /*
   * CAUTION: While this is the default, Blink imposes a 1000-track limit,
   * so the container will max out at 1000px high with this value.
   *
   * Use higher values (and lose precision) to accomodate more / larger items.
   *
   * REFERENCE: https://github.com/chromium/chromium/blob/b90fb984b549a52c4d5549d6a4f39167673f25f1/third_party/blink/renderer/core/style/grid_area.h#L43-L48
   *
   */
  grid-auto-rows: 1px;
}
</style>



// WEBPACK FOOTER //
// app/javascript/components/cm-masonry-layout.vue?bac5c84a